"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapType = exports.BadgeURL = exports.BadgeType = void 0;
var BadgeType;
(function (BadgeType) {
    BadgeType["CodeSize"] = "languages/code-size";
    BadgeType["CommitsPerMonth"] = "commit-activity/m";
    BadgeType["Contributors"] = "contributors";
    BadgeType["Forks"] = "forks";
    BadgeType["GitHubStars"] = "stars";
    BadgeType["InstallSize"] = "npm/dw";
    BadgeType["Issues"] = "issues";
    BadgeType["LastCommit"] = "last-commit";
    BadgeType["License"] = "license";
    BadgeType["LinkedIn"] = "LinkedIn";
    BadgeType["NpmVersion"] = "npm";
    BadgeType["OpenPRs"] = "issues-pr";
    BadgeType["RepoSize"] = "repo-size";
    BadgeType["Version"] = "v/release";
    BadgeType["Visitors"] = "visitors";
})(BadgeType || (exports.BadgeType = BadgeType = {}));
var BadgeURL;
(function (BadgeURL) {
    BadgeURL["LinkedIn"] = "https://www.linkedin.com/in/";
    BadgeURL["Shields"] = "https://img.shields.io/";
    BadgeURL["Visitors"] = "https://visitor-badge.laobi.icu/badge?page_id=";
})(BadgeURL || (exports.BadgeURL = BadgeURL = {}));
var SnapType;
(function (SnapType) {
    SnapType["Day"] = "day";
    SnapType["Hour"] = "hour";
    SnapType["Minute"] = "minute";
    SnapType["Month"] = "month";
    SnapType["Second"] = "second";
    SnapType["Week"] = "week";
    SnapType["Year"] = "year";
})(SnapType || (exports.SnapType = SnapType = {}));
//# sourceMappingURL=structures.js.map